<script>
    import {education} from "../resume-store";
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div class="education">
    {#each $education as school (school.school)}
        <div class="school">

            <div class="time">{school.period}</div>

            <div class="detail">
                <h4>{school.school}</h4>
                <h5>{school.major}</h5>
                <h6>courses : </h6>
                <div class="courses">
                    {#each school.courses as courseList}
                        <ul>
                            {#each courseList as course}
                                <li>{course}</li>
                            {/each}
                        </ul>
                    {/each}
                </div>
            </div>

        </div>
    {/each}
</div>

<!--------------------------------------------------------------------------------------------------------------------->
<style>
    .education {
        flex-grow: 1;
    }
    .school {
        display: flex;
        padding-bottom: 20px;
        /*justify-content: space-between;*/
    }

    .time {
        flex: 1;
    }

    .detail {
        flex: 4;
        padding-left: 2rem;
    }

    .courses {
        display: flex;
        justify-content: space-around;
    }

    .courses ul {
        list-style-type: circle;
        /*margin-left: 12px;*/
        /*min-width: 280px;*/
        }

    .courses li {
        font-size: .95rem;
    }

    @media screen and (max-width: 770px) {
        .school {
            flex-direction: column;
        }
        .detail {
            padding-left: 0;
        }
    }
</style>